import { render, staticRenderFns } from "./BannerPremium.vue?vue&type=template&id=0bf40c3b&scoped=true"
import script from "./BannerPremium.vue?vue&type=script&lang=js"
export * from "./BannerPremium.vue?vue&type=script&lang=js"
import style0 from "./BannerPremium.vue?vue&type=style&index=0&id=0bf40c3b&prod&lang=css"
import style1 from "./BannerPremium.vue?vue&type=style&index=1&id=0bf40c3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf40c3b",
  null
  
)

export default component.exports